// extracted by mini-css-extract-plugin
module.exports = {"container":"video_container__39wFr","videoContainer":"video_videoContainer__2fjSC","video":"video_video__I87ES"};